exports = module.exports = require("../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".filter-hotels-sort .arrow-icon--up{display:inline-flex;transform:rotate(180deg)}.filter-hotels-sort .multiselect{width:auto!important;margin:0 5px}.filter-hotels-sort .multiselect__element{font-size:15px;line-height:15px}body[dir=rtl] .filter-hotels-sort .arrow-icon--up {\n  transform: rotate(-180deg);\n}\n", ""]);

// exports
